import React, { useEffect } from "react";
import { Descriptions, Collapse, Spin, Table, Tag } from "antd";
import moment from "moment-jalaali";
import config from "../../../config";
import StringHelper from "../../helpers/StringHelper";
import { useReportsStore } from "../../../store/slices/createReportsSlice";
import { usePersistedStore } from "../../../store/persisted-store";
import { isEmpty } from "lodash"

const { Panel } = Collapse;

export default function InsuranceDetailsInfo({ paymentInfo }) {
  const { business } = usePersistedStore()
  const reports = useReportsStore()
  const faNum = StringHelper.getFarsiNum;
  const Info = reports.insuranceDetails.infos;
  const LogisticsRequirement = reports.insuranceDetails.infos.LogisticsRequirement;
  const loading = reports.insuranceDetails.loading;
  const currentBusinessDomain = business.currentBusiness?.data?.domain?.includes(',') ? business.currentBusiness?.data?.domain?.split(",")?.[1] : business.currentBusiness?.data?.domain ? business.currentBusiness?.data?.domain : 'bimeh.com';
  const tableData = Info?.Financial?.Installments?.Items.map((item) => ({
    ...item,
    key: item.InstallmentPaymentId,
  }));
  const columns = [
    {
      title: "عنوان",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "مبلغ",
      dataIndex: "Amount",
      key: "Amount",
      render: (value) => `${Math.round(Number(value) / 10).toLocaleString()} تومان`,
    },
    {
      title: "تاریخ",
      dataIndex: "PaymentDate",
      key: "PaymentDate",
      render: (paymentDate) => <span>{paymentDate ? new Date(paymentDate).toLocaleDateString("fa-IR") : '-'}</span>,
    },
    {
      title: "وضعیت",
      dataIndex: "Status",
      key: "Status",
      render: (value) => <span>{value ? value : "-"}</span>,
    },
  ];


  return (
    <div className="collapse-style">
      <Spin style={{ marginTop: "10px" }} spinning={loading}>
        <Collapse accordion>
          <Panel header="اطلاعات بیمه‌گزار " key="1">
            {Info.InsuranceInfo && Info.InsuranceInfo.Insurer && (
              <Descriptions>
                <Descriptions.Item label="نام و نام‌خانوادگی">
                  {Info.InsuranceInfo.Insurer.FullName}
                </Descriptions.Item>
                {Info.InsuranceInfo.Insurer.LatinFirstName && (
                  <Descriptions.Item label="نام لاتین">
                    {Info.InsuranceInfo.Insurer.LatinFirstName}
                  </Descriptions.Item>
                )}
                {Info.InsuranceInfo.Insurer.LatinLastName && (
                  <Descriptions.Item label="نام‌خانوادگی لاتین">
                    {Info.InsuranceInfo.Insurer.LatinLastName}
                  </Descriptions.Item>
                )}
                <Descriptions.Item label="نام پدر">
                  {Info.InsuranceInfo.Insurer.FatherName}
                </Descriptions.Item>
                <Descriptions.Item label="تاریخ تولد">
                  {faNum(
                    moment(Info.InsuranceInfo.Insurer.BirthDate).format(
                      "jYYYY/jM/jD"
                    )
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="پست الکترونیکی">
                  {Info.InsuranceInfo.Insurer.Email}
                </Descriptions.Item>
                <Descriptions.Item label="جنسیت">
                  {Info.InsuranceInfo.Insurer.Gender}
                </Descriptions.Item>
                <Descriptions.Item label="شماره شناسنامه">
                  {faNum(Info.InsuranceInfo.Insurer.IdentityNumber)}
                </Descriptions.Item>
                <Descriptions.Item label="کد ملی">
                  {faNum(Info.InsuranceInfo.Insurer.NationalCode)}
                </Descriptions.Item>
                {Info.InsuranceInfo.Insurer.PassportNumber && (
                  <Descriptions.Item label="شماره پاسپورت">
                    {faNum(Info.InsuranceInfo.Insurer.PassportNumber)}
                  </Descriptions.Item>
                )}
                <Descriptions.Item label="شماره موبایل">
                  {faNum(Info.InsuranceInfo.Insurer.Mobile)}
                </Descriptions.Item>
                <Descriptions.Item label="شماره تلفن">
                  {faNum(Info.InsuranceInfo.Insurer.Phone)}
                </Descriptions.Item>
              </Descriptions>
            )}
            {Info.InsuranceInfo && Info.InsuranceInfo?.SupportExpertFullName && (
              <Descriptions>
                <Descriptions.Item label="پشتیبان">
                  {Info.InsuranceInfo.SupportExpertFullName}
                </Descriptions.Item>
              </Descriptions>)}
          </Panel>
          <Panel header="اطلاعات بیمه‌نامه" key="2">
            {Info.InsuranceInfo && Info.InsuranceInfo.Details && (
              <div>
                <Descriptions>
                  <Descriptions.Item label="بیمه نامه">
                    {Info.InsuranceInfo.BranchName}
                  </Descriptions.Item>
                  <Descriptions.Item label="شرکت بیمه">
                    {faNum(Info.InsuranceInfo.Company.Title)}
                  </Descriptions.Item>
                  <Descriptions.Item label="نوع بیمه نامه">
                    {faNum(Info.InsuranceInfo.Duration)}
                  </Descriptions.Item>
                  <Descriptions.Item label="وضعیت بیمه نامه">
                    {faNum(Info.InsuranceInfo.Status)}
                  </Descriptions.Item>
                  {Info.InsuranceInfo.Details.map((item, index) => {
                    return (
                      <Descriptions.Item key={index + 10} label={item.Title}>
                        {faNum(item.Value)}
                      </Descriptions.Item>
                    );
                  })}
                </Descriptions>
              </div>
            )}
            {LogisticsRequirement &&
              <Descriptions>
                {LogisticsRequirement.Description && <Descriptions.Item label="توضیحات ">
                  {faNum(LogisticsRequirement.Description)}
                </Descriptions.Item>}
              </Descriptions>}
          </Panel>
          <Panel header="اطلاعات پرداخت" key="3">
            {Info.Financial && (
              <div>
                {Info.Financial.Costs &&
                  Info.Financial.Costs.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Descriptions>
                          {item.Amount &&
                            <Descriptions.Item label={item.Title} key={index}>
                              {StringHelper.currencyFormat(item.Amount)} ریال
                            </Descriptions.Item>}
                          {item.SettlementPaymentDate &&
                            <Descriptions.Item label="تاریخ واریز" key={index}>
                              {faNum(moment(item.SettlementPaymentDate).format("jYYYY/jM/jD"))}
                            </Descriptions.Item>}
                          {item.SettlementCreationTime &&
                            <Descriptions.Item label="تاریخ ارسال به مالی" key={index}>
                              {faNum(moment(item.SettlementCreationTime).format("jYYYY/jM/jD"))}
                            </Descriptions.Item>}
                        </Descriptions>
                        {item.Title === "حق بیمه" && paymentInfo && (
                          <Descriptions>
                            {paymentInfo.PayableAmount != null && (
                              <Descriptions.Item label="مبلغ قابل پرداخت">
                                {StringHelper.currencyFormat(paymentInfo.PayableAmount)} ریال
                              </Descriptions.Item>
                            )}
                            {paymentInfo.SumPayment != null && (
                              <Descriptions.Item label="مبلغ پرداختی">
                                {StringHelper.currencyFormat(paymentInfo.SumPayment)} ریال
                              </Descriptions.Item>
                            )}
                            {paymentInfo.AgreementDiscountAmount != null && (
                              <Descriptions.Item label="تخفیف توافقی">
                                {StringHelper.currencyFormat(paymentInfo.AgreementDiscountAmount)} ریال
                              </Descriptions.Item>
                            )}
                            {paymentInfo.TotalDiscountsAmount != null && (
                              <Descriptions.Item label="مبلغ کل تخفیف">
                                {StringHelper.currencyFormat(paymentInfo.TotalDiscountsAmount)} ریال
                              </Descriptions.Item>
                            )}
                          </Descriptions>
                        )}
                      </React.Fragment>
                    );
                  })}
                {!isEmpty(Info.Financial.Payments) &&
                  <Descriptions bordered={true} >
                    {Info.Financial.Payments &&
                      Info.Financial.Payments.map((item, index) => {
                        return (<>
                          <Descriptions.Item label={item.Title} key={index + 10}>
                            {StringHelper.currencyFormat(item.Amount)} ریال
                          </Descriptions.Item>
                          <Descriptions.Item label="تاریخ آپدیت" key={index}>
                            {item.LastModificationTime && faNum(moment(item.LastModificationTime).format("jYYYY/jM/jD"))}
                          </Descriptions.Item>
                          <Descriptions.Item label="وضعیت" key={index}>
                            {item?.PaymentStatusId === 1 ? "پرداخت شده" :
                              item?.PaymentStatusId === 2 ? "  پرداخت نشده" :
                                item?.PaymentStatusId === 3 ? "ناموفق" :
                                  item?.PaymentStatusId === 4 ? "معکوس شده" :
                                    item?.PaymentStatusId === 5 ? "در انتظار" :
                                      item?.PaymentStatusId === 6 ? "حذف شده" :
                                        ""}
                          </Descriptions.Item>
                        </>
                        );
                      })}
                  </Descriptions>}
                <Descriptions>
                  {Info.InsuranceInfo.CategoryLatinName === "debtor" ? <Descriptions.Item label="لینک پرداخت">
                    <a href={window.location.protocol + "//" + currentBusinessDomain + `/ins/payment?id=${Info.InsuranceRequestId}`}>{window.location.protocol + "//" + currentBusinessDomain + `/ins/payment?id=${Info.InsuranceRequestId}`}</a>
                  </Descriptions.Item> : ""}
                </Descriptions>
              </div>
            )}
          </Panel>
          {Info.Financial && Info.Financial.Installments && (
            <Panel header="اطلاعات پرداخت اقساطی" key="4">
              <div>
                <Descriptions>
                  <Descriptions.Item span={1} label="طرح اقساطی">
                    {Info.Financial.Installments.Title}
                  </Descriptions.Item>
                  <Descriptions.Item span={2} label="پیش پرداخت">
                    {StringHelper.currencyFormat(
                      Info.Financial.Installments.PrepaymentAmount
                    )}
                    ریال
                  </Descriptions.Item>
                </Descriptions>
                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={tableData}
                />
              </div>
            </Panel>
          )}
          {LogisticsRequirement &&
            <Panel header="اطلاعات ارسال" key="5">
              <Descriptions>
                {LogisticsRequirement.ReceiverFullName && <Descriptions.Item label="نام دریافت کننده ">
                  {faNum(LogisticsRequirement.ReceiverFullName)}
                </Descriptions.Item>}
                {LogisticsRequirement.Delivery && LogisticsRequirement.Delivery.Date && <Descriptions.Item label=" تاریخ ارسال ">
                  {faNum(
                    moment(LogisticsRequirement.Delivery.Date).format(
                      'jYYYY/jM/jD'
                    ))}
                </Descriptions.Item>}
                {LogisticsRequirement.Delivery && LogisticsRequirement.Delivery.Time && <Descriptions.Item label=" زمان ارسال">
                  {faNum(LogisticsRequirement.Delivery.Time)}
                </Descriptions.Item>}
              </Descriptions>
              <Descriptions>
                {LogisticsRequirement.Email && <Descriptions.Item label="  آدرس ایمیل">
                  {faNum(LogisticsRequirement.Email)}
                </Descriptions.Item>}
                {LogisticsRequirement.ReceiverMobileNumber && <Descriptions.Item label="شماره تماس    ">
                  {faNum(LogisticsRequirement.ReceiverMobileNumber)}
                </Descriptions.Item>}
              </Descriptions>
              {LogisticsRequirement.Delivery &&
                <Descriptions>
                  {LogisticsRequirement.Delivery.Address && <Descriptions.Item span={1} label=" آدرس ارسال">
                    {LogisticsRequirement.Delivery.Address}
                  </Descriptions.Item>}
                </Descriptions>}
              {LogisticsRequirement.ShippingCode &&
                <Descriptions>
                  <Descriptions.Item label="کد پیگیری  مرسوله    ">
                    {faNum(LogisticsRequirement.ShippingCode)}
                  </Descriptions.Item>
                  <Descriptions.Item >
                    <a href={`https://tracking.post.ir/?id=${LogisticsRequirement.ShippingCode}`} target="_blank">سامانه رهگیری مرسولات پستی</a>
                  </Descriptions.Item>

                </Descriptions>}
            </Panel>
          }
          {LogisticsRequirement && LogisticsRequirement.Visit && <Panel header="اطلاعات بازدید" key="6">
            <div>
              <Descriptions>
                {LogisticsRequirement.Visit.Date && <Descriptions.Item label=" تاریخ بازدید ">
                  {faNum(
                    moment(LogisticsRequirement.Visit.Date).format(
                      'jYYYY/jM/jD'
                    ))}
                </Descriptions.Item>}
                {LogisticsRequirement.Visit.Time && <Descriptions.Item label=" زمان بازدید">
                  {faNum(LogisticsRequirement.Visit.Time)}
                </Descriptions.Item>}
              </Descriptions>
              <Descriptions>
                {LogisticsRequirement.Visit.Address && <Descriptions.Item span={1} label=" آدرس بازدید">
                  {LogisticsRequirement.Visit.Address}
                </Descriptions.Item>}
              </Descriptions>
              <Descriptions>
                {LogisticsRequirement.Visit.VisitMethod && <Descriptions.Item span={1} label="روش بازدید">
                  {LogisticsRequirement.Visit.VisitMethod}
                </Descriptions.Item>}
                {LogisticsRequirement.Visit?.UploadedFilesCount >= 0 && <Descriptions.Item span={1} label="تعداد فایل بازدید">
                  {LogisticsRequirement.Visit.UploadedFilesCount}
                </Descriptions.Item>}
              </Descriptions>
            </div>
          </Panel>}

          {Info.InsuranceInfo && Info.InsuranceInfo.InsuranceAddresslisted && (
            <Panel header="آدرس مندرج در بیمه نامه" key="7">
              <div>
                <Descriptions>
                  <Descriptions.Item label="آدرس مندرج در بیمه نامه">
                    {faNum(Info.InsuranceInfo.InsuranceAddresslisted)}
                  </Descriptions.Item>
                </Descriptions>
              </div>
            </Panel>
          )}
          <Panel header="تصاویر آپلود شده" key="8">
            {Info.InsuranceInfo &&
              Info.InsuranceInfo.Files &&
              Info.InsuranceInfo.Files.map((item, index) => {
                return (
                  <a
                    href={`${config.apiUrls()}/v1/insurance/image/?id=${item.Id}`}
                    key={index}
                    alt="bimeh.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div>{item.Title}</div>
                  </a>
                );
              })}
          </Panel>
        </Collapse>
      </Spin>
    </div>
  );
}
